import React from "react";
import { Field, Formik, FormikHelpers } from "formik";
import { Input } from "../../fields/Input";
import appService from "../../../services/app.service";
import { Loading } from "../../Loading";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { IAlk, IExpense } from "../../../core/cm.types";
import { LocationAwareButton } from "../../LocationAwareButton";
import { useTranslation } from "react-i18next";
import { NoAdminAlert } from "../../NoAdminAlert"
import { Checkbox } from "../../fields/Checkbox"

const validationSchema = Yup.object().shape({
    dailyAllowance: Yup.number().typeError("Bitte eine gültige Zahl angeben").required("*")
});

export const ExpenseDetails: React.FunctionComponent<{
    id: string | undefined;
    isAdmin: boolean;
}> = (props) => {
    const { t } = useTranslation();
    const { id, isAdmin } = props;
    const backButton = "/config/expenses"
    const isNew = id === undefined || id === null;
    const title = <h1 className="title is-3">{t("client:headers:tabExpensesDetails")}</h1>
    const history = useHistory();
    const [data, setData] = React.useState<{
        isLoading: boolean;
        data: IExpense;
    }>({
        isLoading: true,
        data: {},
    });

    React.useEffect(() => {
        const fetchData = async () => {
            const data = await appService.getExpense(id);
            setData({
                isLoading: false,
                data: data,
            });
        };

        if (isNew) {
            setData({
                isLoading: false,
                data: {},
            });
        } else {
            fetchData();
        }
    }, []);

    const onSubmit = (
        values: Readonly<IExpense | undefined>,
        formikHelpers: FormikHelpers<Readonly<IAlk>>
    ) => {
        const data = values;

        const submit = async () => {
            if (data !== undefined && data !== null) {
                appService.saveExpense(data).then((modulesResults) => {
                    var location = appService.getLocation();
                    history.push(`/${location}${backButton}`)
                }).catch(() => {
                    alert(t("client:common:errorOnSave"));
                });
            }
        };

        submit();
    };

    if (isAdmin !== true) { return <NoAdminAlert /> }

    return (
        <React.Fragment>
            <div className="section defaultSection">
                <Loading isLoading={data.isLoading}></Loading>
                {data.isLoading === false && (
                    <Formik
                        initialValues={data.data}
                        onSubmit={onSubmit}
                        validateOnMount={true}
                        validationSchema={validationSchema}
                        enableReinitialize
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            isValid,
                            dirty,
                            setFieldValue,
                        }) => (
                            <React.Fragment>
                                <form onSubmit={handleSubmit} className="form">
                                    <div className="columns">
                                        <div className="column">{title}</div>
                                        <div className="column button-header">
                                            <button
                                                type="submit"
                                                className={`button is-link is-small is-pulled-right backAndSaveButton ${isSubmitting ? t("client:common:isLoading") : ""
                                                    }`}
                                                disabled={isSubmitting || !dirty || !isValid}
                                            >
                                                {t("client:common:saveButton")}
                                            </button>
                                            <LocationAwareButton title={t("client:common:backButton")} className="button is-small is-pulled-right backAndSaveButton" relativeLocation={backButton}></LocationAwareButton>
                                        </div>
                                    </div>
                                    <div className="columns">
                                        <div className="column">
                                            <Field
                                                name="vm"
                                                label={t("client:config:columnExpenseVM")}
                                                component={Input}
                                            />
                                        </div>
                                        <div className="column">
                                            <Field
                                                name="nm"
                                                label={t("client:config:columnExpenseNM")}
                                                component={Input}
                                            />
                                        </div>
                                        <div className="column">
                                            <Field
                                                name="dailyAllowance"
                                                type="number"
                                                label={t("client:config:columnExpenseIsDailyallowance")}
                                                component={Input}
                                            />
                                        </div>
                                    </div>
                                    <Field
                                        name="isMealExpense"
                                        label={` ${t("client:config:columnExpenseIsMealExpense")}`}
                                        component={Checkbox}
                                    />
                                    <div className="button-footer">
                                        <button
                                            type="submit"
                                            className={`button is-link is-small is-pulled-right backAndSaveButton${isSubmitting ? t("client:common:isLoading") : ""
                                                }`}
                                            disabled={isSubmitting || !dirty || !isValid}
                                        >
                                            {t("client:common:saveButton")}
                                        </button>
                                        <LocationAwareButton title={t("client:common:backButton")} className="button is-small is-pulled-right backAndSaveButton" relativeLocation={backButton}></LocationAwareButton>
                                    </div>
                                </form>
                            </React.Fragment>
                        )}
                    </Formik>
                )}
            </div>
        </React.Fragment>
    );
};
